module.exports = __webpack_public_path__ + "static/media/Banff.c2c65152.jpg";